"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMergesObj = exports.getColumns = exports.parseFile = void 0;
var XLSX = require('@pengchen/xlsx');
/**
 * 读取文件
 */
var parseFile = function (_a) {
    var file = _a.file;
    return new Promise(function (resolve, reject) {
        var reader = new FileReader();
        var rABS = !!reader.readAsBinaryString;
        reader.onload = function (e) {
            /* Parse data */
            var bstr = e.target && e.target.result;
            var wb = XLSX.read(bstr, {
                type: rABS ? 'binary' : 'array',
                cellStyles: true
            });
            /* Get Tables */
            var tables = [];
            wb.SheetNames.forEach(function (sheetName) {
                var ws = wb.Sheets[sheetName];
                // https://github.com/SheetJS/sheetjs#json
                var dataSource = XLSX.utils.sheet_to_json(ws, { header: 'A', blankrows: true });
                var columns = (0, exports.getColumns)({
                    refStr: ws['!ref'],
                    mergesArr: ws['!merges'] || [],
                });
                tables.push({
                    sheetName: sheetName,
                    dataSource: dataSource,
                    columns: columns,
                });
            });
            resolve({
                wb: wb,
                tables: tables,
            });
        };
        reader.onerror = function (e) {
            reject(e);
        };
        if (rABS)
            reader.readAsBinaryString(file);
        else
            reader.readAsArrayBuffer(file);
    });
};
exports.parseFile = parseFile;
/**
 * 生成列
 */
var getColumns = function (_a) {
    var refStr = _a.refStr, mergesArr = _a.mergesArr;
    var columns = [];
    if (!refStr) {
        return columns;
    }
    var mergesObj = (0, exports.getMergesObj)(mergesArr);
    var columnsLen = XLSX.utils.decode_range(refStr).e.c + 1;
    var _loop_1 = function (colIndex) {
        columns[colIndex] = {
            key: XLSX.utils.encode_col(colIndex),
            title: XLSX.utils.encode_col(colIndex),
            dataIndex: XLSX.utils.encode_col(colIndex),
            mergesObj: mergesObj,
            render: function (value, row, rowIndex) {
                return {
                    children: value,
                    props: mergesObj["".concat(colIndex, ":").concat(rowIndex)],
                };
            },
        };
    };
    for (var colIndex = 0; colIndex < columnsLen; ++colIndex) {
        _loop_1(colIndex);
    }
    return columns;
};
exports.getColumns = getColumns;
/**
 * 获取合并项
 */
var getMergesObj = function (mergesArr) {
    var mergesObj = {};
    mergesArr.forEach(function (m) {
        var msc = m.s.c;
        var msr = m.s.r;
        var mec = m.e.c;
        var mer = m.e.r;
        for (var sc = msc; sc <= mec; sc++) {
            for (var sr = msr; sr <= mer; sr++) {
                mergesObj["".concat(sc, ":").concat(sr)] = {
                    colSpan: msr === sr ? 0 : undefined,
                    rowSpan: 0,
                };
            }
        }
        mergesObj["".concat(msc, ":").concat(msr)] = {
            colSpan: mec - msc + 1,
            rowSpan: mer - msr + 1,
        };
    });
    return mergesObj;
};
exports.getMergesObj = getMergesObj;
